const { createSelector } = require("reselect");

const selectOtpCode = (state) => state.otpDomain.otpCode;

const otpCode = () => createSelector([selectOtpCode], (prf) => prf.data);

const otpCodeError = () => createSelector([selectOtpCode], (prf) => prf.error);

const otpCodeLoading = () =>
  createSelector([selectOtpCode], (prf) => prf.loading);

const selectOtpCodeVerify = (state) => state.otpDomain.otpCodeVerify;

const otpCodeVerify = () =>
  createSelector([selectOtpCodeVerify], (prf) => prf.data);

const otpCodeVerifyError = () =>
  createSelector([selectOtpCodeVerify], (prf) => prf.error);

const otpCodeVerifyLoading = () =>
  createSelector([selectOtpCodeVerify], (prf) => prf.loading);

module.exports = {
  otpCode,
  otpCodeLoading,
  otpCodeError,

  otpCodeVerify,
  otpCodeVerifyError,
  otpCodeVerifyLoading,
};
